import Part from "@/components/body/parts/part";
import { Colors } from "@/components/shared/util";
import { Patient } from "@/store/modules/patient/types";
import SVG from "svg.js";

const icdTextId = "#icdText";
const icdRiskId = "#icdRisk";
export default class Icd extends Part {
  icdText!: SVG.Element;
  icdRisk!: SVG.Element;

  updateData(patient: Patient | null) {
    super.updateData(patient);
    if (!this.atom) {
      return;
    }

    if (!this.icdText) {
      this.icdText = SVG.select(icdTextId, this.container.node).first();
    }

    if (!this.icdRisk) {
      this.icdRisk = SVG.select(icdRiskId, this.container.node).first();
    }

    // innerHTML doesn't work on IE 11
    this.icdText.node.textContent = this.atom.legend;

    if (this.atom.value === 0) {
      this.svgGroup.hide();
    } else {
      const color = this.atom.value === 1 ? Colors.Yellow : Colors.Orange;
      this.svgGroup.show();
      this.icdRisk.attr({ fill: color });
    }
  }
}
